import { PROMO_ID_QUERYSTRING } from '../../constants/promoIdQuery';

export const isPathContainsPromoId = ({ path }: { path?: string }) => {
  if (!path) {
    return false;
  }

  return path.includes(PROMO_ID_QUERYSTRING);
};
